<template>
  <div class="relative p-4 border rounded border-slate-300 dark:border-zinc-700">
    <slot />
    <div>
      <div class="flex flex-col gap-4">
        <div v-for="n in Array.from({ length: 7 }, (v, k) => k + 1)" :key="n">
          <div class="flex gap-2">
            <div class="w-40">
              <div class="h-4 w-5/6 bg-slate-100 dark:bg-zinc-800"></div>
              <div class="h-4 w-2/6 mt-1 bg-slate-100 dark:bg-zinc-800"></div>
            </div>
            <div class="grow flex gap-2 items-center">
              <div class="w-10 h-4 bg-slate-100 dark:bg-zinc-800"></div>
              <div class="w-full h-4 bg-slate-100 dark:bg-zinc-800"></div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script lang="ts" setup></script>
